import axios from "axios";
import { queryParams } from "../../../utils/queryParams";
import { MODULE_LOGICS } from "./constants";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/lifetime_value_and_length/membership_length"
});

export const api = {
  getTable(apiPath, moduleLogic, params) {
    const url = `${apiPath}/get_table`;
    return moduleLogic === MODULE_LOGICS.MEMBERS
      ? instance.get(url, { params })
      : instance.post(url, params);
  },
  getFilters(apiPath, params) {
    return instance.get(`/${apiPath}/get_filters`, { params });
  },
  getRevenueCategories(apiPath, params) {
    return instance.post(`/${apiPath}/get_revenue_categories`, params);
  }
};
